export default {
    'add-external-entity': 'جهة خارجية جديدة',
    'edit-external-entity': 'تعديل جهة خارجية ',
    'this-entity-data': 'بيانات هذه الجهة',
    'staff': 'طاقم العمل'
}